<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
    <b-avatar button variant="primary" class="mb-2 align-baseline">{{nameInitials}}</b-avatar>
  </template>\
  <template slot="dropdown">
    <b-dropdown-header tag="div" class="text-center">
        <strong>Settings</strong>
    </b-dropdown-header>
    <b-dropdown-item @click="editProfile"><i class="fa fa-user"/> Profile</b-dropdown-item>
    <b-dropdown-item @click="changePassword"><i class="fa fa-wrench" /> Change Password</b-dropdown-item>
    <b-dropdown-divider/>
    <b-dropdown-item @click="logout"><i class="fa fa-lock" /> Logout</b-dropdown-item>
</template>
</AppHeaderDropdown>
</template>

<script>
    import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
    import api from "@/services/api.service";
    import { TokenService } from '@/services/storage.service';
    import store from '@/store'
    export default {
      name: 'DefaultHeaderDropdownAccnt',
      components: {
        AppHeaderDropdown
    },
    data: () => {
        return { itemsCount: 42, 
        nameInitials:atob(localStorage.getItem('user_name')) }
    },
    methods: {
        makeToast(message = '',title='Alert',variant='warning') {
            this.toastCount++
            this.$bvToast.toast(message, {
                title:title,
                variant:variant,
                autoHideDelay: 3000
            })
        },
        async logout()
        {
            let response = await api.post('logout');
            if (!response)
                this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

            if(response.status=='success'){
                localStorage.clear()
                TokenService.removeToken();
                api.removeHeader();
                store.state.user.loggedIn=false;
                store.state.user.isAdmin=false;
                this.$router.push({name:"Login"});
            }else
            this.makeToast(`Something wrong happen,please try again.`,'Alert','danger')
        },
        editProfile()
        {
            this.$router.push({name:"Edit Admin Profile",params:{id:atob(localStorage.getItem('user_id'))}});
        },
        changePassword()
        {
            this.$router.push({name:"Change Admin Password"});
        }
    }
}
</script>
